// this is an issue from their docs
// @ts-ignore
import { InitOptions } from 'i18next'
import { enTranslations } from './enTranslations'
import { goalsTranslations } from './goals'
import { painchekTranslations } from './painchek'
import { generalTranslations } from './general'
import { toDosTranslations } from './toDos'
import { reportsTranslations } from './reports'
import { dacTranslations } from './deviceAccessControl'
import { noticeboardTranslations } from './noticeboard'
import { selfServeTranslations } from './selfServe'
import { riskAssessmentReportTranslations } from './riskAssessmentReports'
import { monitoringReportTranslations } from './monitoringReports'
import { serviceUserProfileTranslations } from './serviceUserProfile'
import { privacyOfficersTranslations } from './privacyOfficers'
import { reportingTranslations } from './reporting'
import { gpConnectTranslations } from './gpConnect'
import { incidentReportsTranslations } from './incidentReports'
import { cqiTranslations } from './cqi'
import { pbsTranslations } from './pbs'
import { teamTranslations } from './team'
import { goalReportsTranslations } from './goalReports'
import { cernerTranslations } from './cerner'
import { carePlansTranslations } from './carePlans'
import { accessControlTranslations } from './accessControl'
import { riskAssessmentsTranslations } from './riskAssessments'
import { riskAssessmentFormTranslations } from './riskAssessmentForm'
import { emarV2Translations } from './emarV2'

export const NAMESPACE = {
  GOALS: 'goals',
  TODOS: 'toDos',
  RESOURCES: 'resources',
  PAINCHECK: 'painchek',
  GENERAL: 'general',
  REPORTS: 'reports',
  TEAM: 'team',
  RISK_ASSESSMENT_REPORT: 'riskAssessmentReport',
  RISK_ASSESSMENTS: 'riskAssessments',
  RISK_ASSESSMENTS_FORM: 'riskAssessmentForm',
  MONITORING_REPORTS: 'monitoringReport',
  INCIDENT_REPORTS: 'incidentReport',
  GOAL_REPORTS: 'goalReport',
  DEVICE_ACCESS_CONTROL: 'deviceAccessControl',
  SELF_SERVE: 'selfServe',
  NOTICEBOARD: 'noticeboard',
  SERVICE_USER_PROFILE: 'serviceUserProfile',
  PRIVACY_OFFICERS: 'privacyOfficers',
  REPORTING: 'reporting',
  GP_CONNECT: 'GPConnect',
  CQI: 'CQI',
  PBS: 'PBS',
  CERNER: 'CERNER',
  CARE_PLANS: 'carePlans',
  ACCESS_CONTROL: 'accessControl',
  EMAR_V2: 'emarMedicationStockV2'
}

export const resources: InitOptions['resources'] = {
  en: {
    [NAMESPACE.GOALS]: goalsTranslations,
    [NAMESPACE.TODOS]: toDosTranslations,
    [NAMESPACE.PAINCHECK]: painchekTranslations,
    [NAMESPACE.RESOURCES]: enTranslations,
    [NAMESPACE.GENERAL]: generalTranslations,
    [NAMESPACE.REPORTS]: reportsTranslations,
    [NAMESPACE.TEAM]: teamTranslations,
    [NAMESPACE.RISK_ASSESSMENT_REPORT]: riskAssessmentReportTranslations,
    [NAMESPACE.RISK_ASSESSMENTS]: riskAssessmentsTranslations,
    [NAMESPACE.RISK_ASSESSMENTS_FORM]: riskAssessmentFormTranslations,
    [NAMESPACE.MONITORING_REPORTS]: monitoringReportTranslations,
    [NAMESPACE.INCIDENT_REPORTS]: incidentReportsTranslations,
    [NAMESPACE.GOAL_REPORTS]: goalReportsTranslations,
    [NAMESPACE.DEVICE_ACCESS_CONTROL]: dacTranslations,
    [NAMESPACE.NOTICEBOARD]: noticeboardTranslations,
    [NAMESPACE.SELF_SERVE]: selfServeTranslations,
    [NAMESPACE.SERVICE_USER_PROFILE]: serviceUserProfileTranslations,
    [NAMESPACE.PRIVACY_OFFICERS]: privacyOfficersTranslations,
    [NAMESPACE.REPORTING]: reportingTranslations,
    [NAMESPACE.GP_CONNECT]: gpConnectTranslations,
    [NAMESPACE.CQI]: cqiTranslations,
    [NAMESPACE.PBS]: pbsTranslations,
    [NAMESPACE.CERNER]: cernerTranslations,
    [NAMESPACE.CARE_PLANS]: carePlansTranslations,
    [NAMESPACE.ACCESS_CONTROL]: accessControlTranslations,
    [NAMESPACE.EMAR_V2]: emarV2Translations
  }
}
